import type { FC } from 'react';

import { Box } from '@mui/material';

import { AttachmentsContainer } from './components/AttachmentsContainer/AttachmentsContainer';
import { useAttachments } from './hooks/useAttachments';

import type { SxProps, Theme } from '@mui/material';
import type { DocumentsEntityTypeEnum } from '@shared/enums/documentEntityType.enum';
import type { PhotoEntityTypeEnum } from '@shared/enums/photoEntityType.enum';
import type { CropConfig, MediaType } from '@shared/models/media.model';

export type AttachmentsProps = {
  uploadFileButtonId?: string;
  uploadFileInputId?: string;
  fileNameLabelId?: string;
  attachmentType: 'photo' | 'file';
  entity_id?: number | null;
  entityType?: DocumentsEntityTypeEnum | PhotoEntityTypeEnum;
  attachments: MediaType[];
  maxAttachmentsLength?: number;
  handleAddAttachment: (attachments: MediaType[]) => void;
  handelUpdateAttachment?: (attachments: MediaType[]) => void;
  isDeleteWithAutoSave?: boolean;
  isCanAddMediaFromClipboard?: boolean;
  isCanAddMedia?: boolean;
  isDisabledUploadFile?: boolean;
  isShowCoverPhoto?: boolean;
  isShowActionMenu?: boolean;
  heightImage?: number;
  sxUploadContainer?: SxProps<Theme>;
  sxAttachContainer?: SxProps<Theme>;
  uploadSize?: 'small' | 'medium';
  isUploaderFullHeight?: boolean;
  showDeletePopupOnDelete?: true;
  isFullWidth?: boolean;
  showItemCaption?: boolean;
  cropConfig?: CropConfig;
  aspectRatio?: string | number;
  handleChangeCoverPhoto?: (newCoverID: number) => void;
  handleDeleteCoverPhoto?: (newCoverID: number, isCover: undefined | boolean) => void;
  tooltipSettings?: {
    color?: 'dark' | 'light';
    tooltipText: string;
    tooltipWithIcon: boolean;
  };
  setIsLoadingAttachment?: (val: boolean) => void;
  permission?: {
    isDelete?: boolean;
    isDownload?: boolean;
    isUpdate?: boolean;
  };
  attachmentCardsGridConfig?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
    xl?: number;
  };
  attachmentCardsColumnSpacingConfig?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
  attachmentCardsRowSpacingConfig?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
  isProtectedUrl?: boolean;
  customAcceptedFormat?: string[];
};
export const Attachments: FC<AttachmentsProps> = (props) => {
  const {
    attachmentType = 'photo',
    attachments,
    handleAddAttachment,
    handelUpdateAttachment,
    isDeleteWithAutoSave = false,
    entityType,
    permission = { isDelete: true, isDownload: true, isUpdate: false },
    cropConfig,
    isShowActionMenu = false,
    handleDeleteCoverPhoto,
    setIsLoadingAttachment,
    showDeletePopupOnDelete,
    isProtectedUrl = false,
  } = props;

  const {
    handleUpdateLoadingAttachment,
    handleDeleteLoadingAttachment,
    handleAddLoadingAttachment,
    onAddAsyncAttachment,
    handleOpenViewModal,
    loadingAttachment,
    handleDeleteAttachment,
  } = useAttachments({
    handelUpdateAttachment,
    handleAddAttachment,
    setIsLoadingAttachment,
    attachments,
    attachmentType,
    entityType,
    permission,
    cropConfig: cropConfig as CropConfig,
    handleDeleteCoverPhoto,
    showDeletePopupOnDelete,
    isShowActionMenu,
    isDeleteWithAutoSave,
    isProtectedUrl,
  });

  return (
    <Box sx={{ width: '100%' }}>
      <AttachmentsContainer
        handleOpenViewModal={handleOpenViewModal}
        loadingAttachment={loadingAttachment}
        handleUpdateLoadingAttachment={handleUpdateLoadingAttachment}
        onAddAsyncAttachment={onAddAsyncAttachment}
        handleDeleteLoadingAttachment={handleDeleteLoadingAttachment}
        handleDeleteAttachment={handleDeleteAttachment}
        handleAddLoadingAttachment={handleAddLoadingAttachment}
        {...props}
      />
    </Box>
  );
};
